<template>
  <div>
    <v-card>
      <v-card-title>
        My Academies
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" md="4" offset-md="8">
            <v-text-field
              v-model="filter"
              :append-icon="icons.mdiMagnify"
              label="Search Academies"
              single-line
              hide-details
              dense
              outlined
              @input="filterAcademies"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-data-table
        :headers="headers"
        :items="filteredAcademies"
        :loading="isLoading"
        :items-per-page="10"
        class="elevation-1"
      >
        <template #item.actions="{ item }">
          <div class="d-flex justify-end" style="max-width: 150px">
            <v-icon @click="goToAcademy(item)">
              {{ icons.mdiEye }}
            </v-icon>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mdiMagnify, mdiEye } from '@mdi/js'
import { ref, onMounted } from 'vue'
import useAcademies from '@/composables/api/academies'
import useAuth from '@/composables/useAuth'
import { useRouter } from '@/utils/index'

export default {
  setup() {
    const { fetchAcademyById, getUserAcademy } = useAcademies()
    const { hasRole } = useAuth()
    const { router } = useRouter()

    const filter = ref('')
    const filteredAcademies = ref([])
    const isLoading = ref(false)
    const myAcademies = ref([])

    const headers = [
      { text: 'Name', value: 'name' },
      { text: 'ID', value: 'id' },
      {
        text: 'Actions', value: 'actions', sortable: false, align: 'end', width: '150px',
      },
    ]

    const filterAcademies = () => {
      const search = filter.value ? filter.value.toLowerCase() : ''
      if (search === '') {
        filteredAcademies.value = myAcademies.value
      } else {
        filteredAcademies.value = myAcademies.value.filter(academy => academy.name.toLowerCase().includes(search))
      }
    }

    const fetchMyAcademies = async () => {
      isLoading.value = true
      try {
        if (hasRole(['COACH'])) {
          const user = await getUserAcademy()
          const userCompanyIds = Array.isArray(user.companyId) ? user.companyId : (user.companyId ? [user.companyId] : [])

          // Fetch details for each academy
          const academyPromises = userCompanyIds.map(async id => {
            try {
              return await fetchAcademyById(id)
            } catch (error) {
              console.error(`Failed to fetch academy ${id}:`, error)

              return null
            }
          })

          const academyResults = await Promise.all(academyPromises)
          myAcademies.value = academyResults.filter(academy => academy !== null)
          filteredAcademies.value = myAcademies.value
        }
      } catch (error) {
        console.error('Failed to fetch my academies:', error)
      } finally {
        isLoading.value = false
      }
    }

    const goToAcademy = item => {
      localStorage.setItem('selectedAcademy', JSON.stringify({
        id: item.id,
        name: item.name,
      }))
      router.push({ name: 'academy-details', params: { id: item.id } })
    }

    onMounted(fetchMyAcademies)

    return {
      filter,
      filteredAcademies,
      filterAcademies,
      goToAcademy,
      isLoading,
      headers,
      icons: { mdiMagnify, mdiEye },
    }
  },
}
</script>
